var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.asc ? Object.entries(_vm.orders) : Object.entries(_vm.orders).reverse()),function(ref,i){
var price = ref[0];
var amount = ref[1];
return _c('div',{key:i,staticClass:"stats-row"},[_c('span',[_vm._v(_vm._s(_vm.formatCapital(price)))]),_c('span',{staticClass:"stat"},[_vm._v(_vm._s(_vm.formatAmount(amount)))])])}),(Object.keys(_vm.orders).length === 0)?_c('div',{staticClass:"empty"},[_vm._v(" NO ORDERS ")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }